export const CREATE_NEW_CHANNEL = 'CREATE_NEW_CHANNEL'
export const CREATE_NEW_CHANNEL_SUCCESS = 'CREATE_NEW_CHANNEL_SUCCESS'
export const CREATE_NEW_CHANNEL_FAILED = 'CREATE_NEW_CHANNEL_FAILED'

export const LEAVE_CHANNEL = 'LEAVE_CHANNEL'
export const LEAVE_CHANNEL_SUCCESS = 'LEAVE_CHANNEL_SUCCESS'
export const LEAVE_CHANNEL_FAILED = 'LEAVE_CHANNEL_FAILED'
